import Vue from 'vue'
import Vuex from 'vuex'
import './firebaseConfig'
import UserModule from './store/user'
import KreisModule from './store/kreis'
import AbrechnungModule from './store/abrechnung'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    UserModule,
    KreisModule,
    AbrechnungModule
  }
})

export default store
